import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoadingEmpty = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 22 22",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#F2F2F2",
		d: "M22 11c0 6.075-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0s11 4.925 11 11M2.751 11a8.249 8.249 0 1 0 16.498 0A8.249 8.249 0 0 0 2.75 11"
	})
});
export default SvgLoadingEmpty;
